import { DotLottiePlayer } from '@dotlottie/react-player';
import Loader from './LoaderEfex.json';

const GlobalLoader = () => (
  <div className="flex items-center justify-center h-screen bg-primary-text">
    <DotLottiePlayer className="contents" src={Loader} autoplay loop />
  </div>
);

export default GlobalLoader;
